// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponMemberMemberNumberStatusMemberNumberStatusRequest {
    static getAttributeTypeMap() {
        return CouponMemberMemberNumberStatusMemberNumberStatusRequest.attributeTypeMap;
    }
}
CouponMemberMemberNumberStatusMemberNumberStatusRequest.discriminator = undefined;
CouponMemberMemberNumberStatusMemberNumberStatusRequest.attributeTypeMap = [
    {
        "name": "memberId",
        "baseName": "memberId",
        "type": "string"
    },
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    }
];
//# sourceMappingURL=couponMemberMemberNumberStatusMemberNumberStatusRequest.js.map